<template>
  <div
    class="catalog-filter"
    :class="{
      'catalog-filter--menu': isFilterMenu || isCategoriesMenu,
      'catalog-filter--categories-menu': isCategoriesMenu,
    }"
  >
    <FilterItemComponent v-if="!isFilterMenu" title="Навигация" :opened="true">
      <ul class="catalog-filter__categories">
        <li v-for="(item, i) in categories" :key="i">
          <router-link
            :to="{ name: 'catalog', params: { id: item.id } }"
            :class="{ 'catalog-filter__category--active': $route.params.id === item.id }"
            class="catalog-filter__category"
          >
            <span>{{ item.title }}</span>
            <button
              v-if="item.childs && item.childs.length"
              :class="{ active: active === item.id }"
              @click.prevent="setActive(item.id, 'active')"
              class="btn"
            >
              <IconComponent name="arrow-right-1" />
            </button>
          </router-link>
          <ul :ref="'categoryChilds' + item.id" class="catalog-filter__category-childs" v-if="item.childs">
            <li v-for="(child, index) in item.childs" :key="index">
              <router-link
                :to="{ name: 'catalog', params: { id: child.id } }"
                :class="{ 'catalog-filter__category--active': $route.params.id === child.id }"
                class="catalog-filter__category"
              >
                <span>{{ child.title }}</span>
                <button
                  v-if="child.childs && child.childs.length"
                  :class="{ active: activeChild === child.id }"
                  @click.prevent="setActive(child.id, 'activeChild')"
                  class="btn"
                >
                  <IconComponent name="arrow-right-1" />
                </button>
              </router-link>
              <ul
                :ref="'categoryChilds' + child.id"
                class="catalog-filter__category-childs"
                v-if="child.childs"
              >
                <li v-for="(subchild, k) in child.childs" :key="k">
                  <router-link
                    :to="{ name: 'catalog', params: { id: subchild.id } }"
                    :class="{ 'catalog-filter__category--active': $route.params.id === subchild.id }"
                    class="catalog-filter__category"
                  >
                    <span>{{ subchild.title }}</span>
                    <button v-if="subchild.childs && subchild.childs.length" class="btn">
                      <IconComponent name="arrow-right-1" />
                    </button>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </FilterItemComponent>
    <FilterItemComponent v-if="!isCategoriesMenu" title="Цена">
      <div class="catalog-filter__price">
        <CatalogRangeSlider @change="priceChange" :min-value="minValue" :max-value="maxValue" />
        <CheckboxComponent :checked="form.availability" @change="form.availability = !form.availability">
          <span> Только в наличии </span>
        </CheckboxComponent>
        <CheckboxComponent :checked="form.in_share" @change="form.in_share = !form.in_share">
          <span> Показать товары только со скидкой </span>
        </CheckboxComponent>
      </div>
    </FilterItemComponent>
    <FilterItemComponent v-if="!isCategoriesMenu && !isBrandPage" title="Бренд">
      <div class="catalog-filter__brands">
        <InputComponent v-model="brandsSearch" placeholder="Поиск по брендам" />
        <div v-if="brands && brands.length" class="catalog-filter__brands-list">
          <CheckboxComponent
            v-for="(item, i) in brands"
            :key="i"
            :checked="isChecked(item.id)"
            @change="toggleValue(item.id)"
          >
            <span> {{ item.title }} </span>
          </CheckboxComponent>
        </div>
        <span v-else-if="brandsSearch">Ничего не найдено</span>
        <span v-else>Бренды отсутствуют</span>
      </div>
    </FilterItemComponent>
    <button
      v-if="JSON.stringify(this.form) !== JSON.stringify(this.defaultForm)"
      @click="reset"
      type="button"
      class="btn btn--md btn--main"
    >
      Сбросить
    </button>
  </div>
</template>

<script>
import FilterItemComponent from "./FilterItemComponent.vue";
import CheckboxComponent from "components/inputs/CheckboxComponent.vue";
import CatalogRangeSlider from "./CatalogRangeSlider.vue";
import IconComponent from "components/IconComponent.vue";
import InputComponent from "components/inputs/InputComponent.vue";

// переделать численные параметры
function parseParams(query) {
  Object.keys(query).forEach((key) => {
    try {
      query[key] = JSON.parse(query[key]);
    } catch (e) {
      return null;
    }
  });
  return query;
}

export default {
  name: "CatalogFiltersComponent",
  props: {
    loading: Boolean,
    isFilterMenu: Boolean,
    isCategoriesMenu: Boolean,
  },
  data() {
    return {
      isBrandPage: false,
      active: undefined,
      activeChild: undefined,
      inputDebounceTimeout: null,
      minValue: 0,
      maxValue: 500000,
      brandsSearch: "",
      params: {},
      form: {
        price_from: 0,
        price_to: 500000,
        availability: false,
        in_share: false,
        brand_id: [],
      },
      defaultForm: {
        price_from: 0,
        price_to: 500000,
        availability: false,
        in_share: false,
        brand_id: [],
      },
    };
  },
  watch: {
    form: {
      handler() {
        if (this.inputDebounceTimeout) {
          clearTimeout(this.inputDebounceTimeout);
        }
        this.inputDebounceTimeout = setTimeout(() => {
          this.setUrlParams();
          this.setVariables();
          // this.$emit("filter", this.form);
        }, 500);
      },
      deep: true,
    },
  },
  created() {
    this.params = this.parseParams(this.$route.query);
    this.setForm();
  },
  mounted() {
    this.isBrandPage = new URLSearchParams(window.location.search).get("brands_item_id");
  },
  computed: {
    categories() {
      return this.$store.state.categories;
    },
    brands() {
      return this.$store.state.all_brands.filter((item) =>
        item.title.toLowerCase().includes(this.brandsSearch.toLowerCase())
      );
    },
  },
  methods: {
    setActive(id, active) {
      let el = this.$refs[`categoryChilds${id}`][0];
      if (id !== this[active]) {
        if (this[active]) {
          this.$refs[`categoryChilds${this[active]}`][0].style.height = 0; // закрываем предыдущий
        }
        this[active] = id;
        // el.style.height = el.scrollHeight + "px";
        el.style.height = "auto";
      } else {
        this[active] = undefined;
        el.style.height = 0;
      }
    },
    // isActive(category) {
    //   return (
    //     this.active === category.id ||
    //     (category.childs && category.childs.map((item) => item.id).includes(this.active))
    //   );
    // },
    setUrlParams() {
      const urlParams = new URLSearchParams();
      Object.keys(this.form).forEach((key) => {
        if (key === "brand_id") {
          if (this.form[key] && this.form[key].length) {
            urlParams.set(key, JSON.stringify(this.form[key]));
          }
        } else if (this.form[key] !== undefined) urlParams.set(key, this.form[key]);
      });
      history.pushState({}, null, location.origin + location.pathname + "?" + urlParams.toString());
    },
    setForm() {
      if (this.params) {
        Object.keys(this.form).forEach((key) => {
          if (key === "brand_id" && !Array.isArray(this.params[key])) {
            if (this.params[key]) this.form[key] = [this.params[key]];
          } else if (this.params[key]) this.form[key] = this.params[key];
        });
      }
    },
    setVariables() {
      this.$store.state.variables = JSON.parse(JSON.stringify(this.form));
    },
    reset() {
      this.form = JSON.parse(JSON.stringify(this.defaultForm));
      this.$store.state.variables = {};
    },
    priceChange(range) {
      this.form.price_from = range.min;
      this.form.price_to = range.max;
    },
    isChecked(id) {
      return this.form.brand_id && this.form.brand_id.includes(id);
    },
    toggleValue(id) {
      if (this.form.brand_id.includes(id)) {
        this.form.brand_id.splice(this.form.brand_id.indexOf(id), 1);
        return;
      }
      this.form.brand_id.push(id);
    },
    parseParams,
  },
  components: {
    InputComponent,
    IconComponent,
    CatalogRangeSlider,
    CheckboxComponent,
    FilterItemComponent,
  },
};
</script>

<style lang="stylus">
.catalog-filter {
  display grid
  align-items start
  grid-gap 15px
  background: var(--white);
  border-radius: var(--main_radius);

  &:not(&--menu) {
    +below(860px) {
      display none
    }
  }

  &--menu {
    .filter-item__header {
      font-size 1em
    }

    .check {
      font-size 0.875em
    }
  }

  &--categories-menu {
    .filter-item {
      border none
    }

    .filter-item__header {
      display none
    }

    .catalog-filter__categories {
      max-height none

      > li:not(:last-child) {
        border none
      }
    }
  }

  &__header {
    border-bottom: 1px solid var(--blue-500);
    display grid
    grid-gap 8px
    padding-bottom 16px
  }

  &__header-top {
    display flex
    align-items center
    justify-content space-between
  }

  &__title {
    font-weight: normal;
    font-size: 1.125em;
    line-height: 28px;
    display: flex;
    align-items: center;
    color: var(--body-color);
  }

  &__body {
    display flex
    flex-direction column
    grid-gap 16px

    &-container {
      display grid
      grid-gap 30px
    }
  }

  &__categories {
    display grid
    max-height 572px
    overflow-y auto
		scrollbar-width: thin

    > li {
      display grid

      &:not(:last-child) {
        border-bottom 1px solid var(--gray)
      }
    }
  }

  &__category {
    padding 10px 40px 10px 20px
    font-size: 0.875em
    line-height: 145%;
    gap 8px
    display flex
    align-items center
    justify-content space-between

    //&:hover {
    //  background var(--gray)
    //}

    &--active {
      color: var(--main-color-75);

      .icon svg path {
        stroke: var(--main-color-75);
      }
    }

    .icon {
      width 12px
      height 12px
    }

    > .btn {
      height 40px
      width 40px
      position absolute
      right 0
      top 0
      bottom 0
      border-radius 0

      &:hover {
        background var(--gray)
      }

      &.active {
        .icon {
          transition var(--transition)
          transform rotate(90deg)
        }
      }
    }

    &-childs {
      padding-left 10px
      height 0
      min-height 0
      overflow hidden
      transition var(--transition)
    }
  }

  &__price {
    padding 20px
    display grid
    grid-gap 20px
  }

  &__brands {
    padding 20px
    padding-right 10px

    .input {
      width 100%
      height 40px
      margin-bottom: 10px
    }

    &-list {
      display grid
      max-height 260px
      overflow-y auto
			scrollbar-width: none
    }

    .check {
      padding 5px 0
    }
  }

  &__checkboxes {
    display grid
    max-height 290px
    overflow-y auto

    .check {
      color var(--body-color-muted)
      padding 8px 0
      transition var(--transition)

      &:hover {
        color var(--main-color)

        .check__state {
          border-color var(--main-color)
        }
      }
    }
  }

  &__colors {
    display flex
    gap 12px
    flex-wrap wrap
    align-items flex-start

    li {
      display inline-flex
    }

    label {
      cursor pointer
      width 24px
      height 24px
      flex-shrink 0
      border-radius 100%
      outline 2px solid transparent
      transition outline-color var(--transition)

      &.active {
        outline-color var(--main-color)
      }
    }
  }
}
</style>
